<template>
  <div class="container">
    <a-table
      :columns="tableColumns"
      :data-source="videoList"
      size="middle"
      :customRow="handleClick"
      :rowKey="record => record.videoId"
      :pagination="{total: videoTotalCount, pageSize, current: pageNum }"
      @change="changPagination"
    >
      <span class="link-playback" slot="action">
        <a-icon type="play-circle" class="icon-play" />回放
      </span>
    </a-table>

    <a-modal
      title="播放回放视频"
      :visible="showPlaybackDialog"
      :footer="null"
      :z-index="1001"
      width="70%"
      centered
      :destroyOnClose="true"
      @cancel="handleCancel"
    >
      <div class="video-player">
        <div class="video-player-inner">
          <VideoPlayer :videoId="curVideo.videoId"/>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
const tableColumns = [
  {
    title: '课程名称',
    dataIndex: 'liveName',
    key: 'liveName',
    scopedSlots: { customRender: 'name' },
    width: 300,
    ellipsis: true,
  },
  {
    title: '老师',
    dataIndex: 'teacherName',
    key: 'teacherName',
  },
  {
    title: '开始时间',
    dataIndex: 'actualStartTime',
    key: 'actualStartTime',
  },
  {
    title: '结束时间',
    dataIndex: 'actualEndTime',
    key: 'actualEndTime',
  },
  {
    title: '操作',
    key: 'action',
    width: 80,
    scopedSlots: { customRender: 'action' },
  }
]
import VideoPlayer from './VideoPlayer'
export default {
  name: 'VideoList',
  props: {
    searchVideoListValue: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
    VideoPlayer
  },
  data () {
    return {
      showPlaybackDialog: false,
      tableColumns,
      searchValue: '',
      pageNum: 1,
      pageSize: 10,
      videoList: [],
      videoTotalCount: 0,
      curVideo: {}
    }
  },
  watch: {
    searchVideoListValue: {
      handler(nVal) {
        console.log('search', nVal)
        this.pageNum = nVal.pageNum
        this.pageSize = nVal.pageSize
        this.searchValue = nVal.searchValue
        this.videoList = []
        this.inspectSearchVideoByPage()
      },
      deep: true
    }
  },
  mounted() {
    this.inspectSearchVideoByPage()
  },
  methods: {
    changPagination(pagination) {
      const { current } = pagination
      this.pageNum = current
      this.inspectSearchVideoByPage()
    },
    handleClick(record, index) {
      return {
        on: {
          click: () => {
            console.log(record, index)
            this.curVideo = record
            this.viewPlayback(record)
          }
        }
      }
    },
    // 查看回放
    viewPlayback() {
      this.showPlaybackDialog = true
    },
    handleCancel() {
      this.showPlaybackDialog = false
    },

    // 直播列表
    async inspectSearchVideoByPage () {
      try {
        const { classroomCode } = this.$route.query
        const { pageNum, pageSize, searchValue } = this
        const result = await this.$http.inspectSearchVideoByPage({
          classroomCode,
          keywords: searchValue,
          pageNum,
          pageSize
        })
        if (result.code !== 200) return
        this.videoList = (result.rt || {}).list || []
        this.videoTotalCount = (result.rt || {}).totalCount || 0
        this.$emit('updateVideoList', {
          videoTotalCount: this.videoTotalCount
        })
      } catch (err) {
        console.log('直播列表err', err)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .container{
    ::v-deep.ant-table-thead tr th {
      background: #f6f6f6;
    }
    .link-playback{
      color: #5F60D3;
      cursor: pointer;
      &:hover{
        color: #1572FF;
      }
      .icon-play{
        margin-right: 5px;
      }
    }
  }
  .video-player{
    height: 0;
    padding-top: calc(100% * 9 / 16);
    position: relative;
    .video-player-inner{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
</style>
<style>

.prism-player .prism-info-left-bottom{
  left: 70px!important;
  bottom: 38px;
}
</style>